import { atomWithReset } from 'jotai/utils';
import { domain } from 'modules/data';

export const netSuiteExpenseLinesState = atomWithReset<
    (domain.NetSuiteExpenseLineExpenseReport & {
        id: string;
        isEmpty: boolean;
    })[]
>([]);
